import "./tag-item.sass";

type Props = {
  tagTitle: string;
};
const TagItem = ({ tagTitle }: Props) => {
  return <div className="tag-item">{tagTitle}</div>;
};

export default TagItem;
